import { getSupabaseClient } from '../../lib/supabase'

export type AccountDeletionResult = {
  message: string
  requiresOwnershipTransfer: boolean
  request: {
    id: string
    status: string
    requested_at: string
    retention_reason: string | null
    retained_data_classes: string[]
  }
}

export async function requestAccountDeletion(input: { email: string; confirmation: string }): Promise<AccountDeletionResult> {
  const invocation = await getSupabaseClient().functions.invoke('request-account-deletion', { body: input })
  if (invocation.error) throw invocation.error
  const data: unknown = invocation.data
  if (!data || typeof data !== 'object') throw new Error('Deletion service returned an invalid response.')
  const payload = data as Record<string, unknown>
  if (typeof payload.message !== 'string' || typeof payload.requiresOwnershipTransfer !== 'boolean' || !payload.request) {
    throw new Error(typeof payload.error === 'string' ? payload.error : 'Deletion request could not be confirmed.')
  }
  return payload as AccountDeletionResult
}
